export const ActionName = {
  SUBMIT_LEAD: 'SUBMIT_LEAD',
};
